import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonAriaLabel: {
		id: 'insights-next-best-task-filter-button.button-aria-label',
		defaultMessage: 'Your work suggestions panel',
		description:
			'The aria-label for the button which controls showing/hiding the "work suggestions" panel',
	},
	buttonTooltip: {
		id: 'insights-next-best-task-filter-button.button-tooltip',
		defaultMessage: 'Work suggestions',
		description:
			'The tooltip that will be displayed when hovering on the button which controls visibility of the work suggestions panel',
	},
	presenceActionIconLabelNonfinal: {
		id: 'insights-next-best-task-filter-button.presence-action-icon-label-nonfinal',
		defaultMessage: 'New work suggestions',
		description: 'The label for presence action icon (notification)',
	},
});
